import { tCaseColorsSet } from '@/Interfaces/colors';

export const colors: tCaseColorsSet = [
    {
        name: 'серый',
        hex: '#999993',
    },
    {
        name: 'синий',
        hex: '#00067F',
    },
    {
        name: 'черный',
        hex: '#1F1F1F',
    },
    // {
    //     name: 'оранжевый',
    //     hex: '#F58214',
    // },
];

export const frameNodeNameRGB = 'back';
export const faceNodeNameRGB = 'front';

export type typeNodeNameRGB = 'back' | 'front';
